<template>
  <div>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-end">
        <add-button
          v-if="isAdjusted"
          :btn-label="$i18n.t('banner')"
          @click.native="$router.push('/banner/list/Banner_List/create')"
        />
        <export-button v-if="isAdjusted" class="ml-2" @onExport="openReportModal" />
      </b-col>
      <b-col cols="12" class="d-flex justify-content-end mt-1">
        <div class="banner-search-container">
          <search
            :on-search-input="(searchValue) => $emit('onSearch', searchValue)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import { watch, ref, getCurrentInstance, reactive } from "@vue/composition-api";
import useModal from "@/@core/components/base-modal/hooks/useModal";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";

export default {
  components: {
    BRow,
    BCol,
    AddButton,
    Search,
    ExportButton,

    HistoryReportModal,
  },
  props: {
    isAdjusted: Boolean,
  },
  setup() {
    const vm = getCurrentInstance().proxy;

    const openReportModal = () => {
      vm.$emit("onOpenExportModal");
    };

    return {
      openReportModal,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/banner/banner-table.css";
</style>
